import React, { Component } from 'react';
import { compose } from 'redux';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { connect } from 'react-redux';

import { bookingFormInitialValues } from '../store/reducers';
import TextInput from './TextInput';
import AresInput from './AresInput';
import Select from './Select';
import { getCountries }  from '../enums/countries';
import { isWithoutAccommodation } from '../apiHelpers';
import { setStep } from '../store/actions';
import { guestFields, companyFields } from '../enums/Guest';
import { SANDAMIANO_HOTEL_ID } from '../utils';
import CheckboxInput from './CheckboxInput';
import GuestDetails from './GuestDetails';
import withLocalize from '../withLocalize';
import T from './Translate';
import {getTerms} from "../utils";

import DiscountCode from './DiscountCode';

class Step4 extends Component {

	componentWillMount() {
		this.props.dispatch(setStep(4));
	}

	render() {

		const { formValues, hotelId, translate: t, canContinue } = this.props;
		const withoutAccommodation = isWithoutAccommodation(formValues);

		return (
			<section className="container">
				{hotelId === SANDAMIANO_HOTEL_ID && !withoutAccommodation &&
				<GuestDetails/>
				}

				<fieldset className="fieldset">
					<legend><T id="Step4.guestFields.title" /></legend>

					{/* u rezervace bez ubytování se vyplňuje pouze jméno a příjmení, bez detailů hostů */}
					{(hotelId !== SANDAMIANO_HOTEL_ID || withoutAccommodation) &&
					<React.Fragment>
						{[0].map((row, index) => (
							<div className="fieldset__fields-row" key={index}>
								{[row, row+1].map((field, index) => (
									<Field
										component={TextInput}
										name={guestFields[field].name}
										label={t(guestFields[field].label)}
										key={guestFields[field].name}
										textarea={guestFields[field].textarea || false}
										required={guestFields[field].required !== undefined ? guestFields[field].required : true}
									/>
								))}
							</div>
						))}
					</React.Fragment>
					}

					<div className="fieldset__fields-row">
						{[2].map((field, index) => (
							<Field
								component={TextInput}
								name={guestFields[field].name}
								label={t(guestFields[field].label)}
								key={guestFields[field].name}
								textarea={guestFields[field].textarea || false}
								required={guestFields[field].required !== undefined ? guestFields[field].required : true}
							/>
						))}

						{[3].map((field, index) => (
							<Field
								component={TextInput}
								name={guestFields[field].name}
								label={t(guestFields[field].label)}
								key={guestFields[field].name}
								textarea={guestFields[field].textarea || false}
								required={guestFields[field].required !== undefined ? guestFields[field].required : true}
								placeholder="+420"
								disabled={!canContinue}
							/>
						))}
					</div>

					{hotelId !== SANDAMIANO_HOTEL_ID &&
					<React.Fragment>
						{[4,6].map((row, index) => (
							<div className="fieldset__fields-row" key={index}>
								{[row, row+1].map((field, index) => (
									<Field
										component={TextInput}
										name={guestFields[field].name}
										label={t(guestFields[field].label)}
										key={guestFields[field].name}
										textarea={guestFields[field].textarea || false}
										required={guestFields[field].required !== undefined ? guestFields[field].required : true}
									/>
								))}
							</div>
						))}
					</React.Fragment>
					}
				</fieldset>

				<DiscountCode />

				{hotelId !== SANDAMIANO_HOTEL_ID &&
				<fieldset className="fieldset">
					<legend><T id="Step4.companyFields.title" /></legend>

					<Field
						component={CheckboxInput}
						name="isCompany"
						id="guest-isCompany"
						label={t('Step4.companyFields.isCompany')}
					/>

					<div className={!formValues.isCompany ? 'hidden' : ''}>
						<div className="fieldset__fields-row">
							<Field
								component={AresInput}
								name="companyIc"
								label={t('enums.Guest.companyFields.ic')}
								required={false}
							/>
						</div>

						<div className="fieldset__fields-row">
							{[0, 2].map((field, index) => (
								<Field
									component={TextInput}
									name={companyFields[field].name}
									label={t(companyFields[field].label)}
									key={companyFields[field].name}
									required={companyFields[field].required !== undefined ? companyFields[field].required : true}
								/>
							))}
						</div>

						<div className="fieldset__fields-row">
							{[3, 4].map((field, index) => (
								<Field
									component={TextInput}
									name={companyFields[field].name}
									label={t(companyFields[field].label)}
									key={companyFields[field].name}
									required={companyFields[field].required !== undefined ? companyFields[field].required : true}
								/>
							))}
						</div>

						<div className="fieldset__fields-row">
							<Field
								component={TextInput}
								name="companyPostCode"
								label={t('enums.Guest.companyFields.postCode')}
								required={true}
							/>
							<Field
								component={Select}
								name="companyCountry"
								label={t('enums.Guest.companyFields.country')}
								options={getCountries(t)}
								searchable
							/>
						</div>
					</div>

				</fieldset>
				}

			</section>
		);
	}
}

export default compose(
	reduxForm({
		form: 'bookingForm',
		initialValues: bookingFormInitialValues,
		destroyOnUnmount: false,
	}),
	connect((state) => ({
		formValues: getFormValues('bookingForm')(state),
		terms: getTerms(state.app),
		canContinue: state.app.canContinue,
		hotelId: state.app.hotelId,
	})),
	withLocalize,
)(Step4);



// WEBPACK FOOTER //
// ./src/components/Step4.jsx